export default {"src":"/_next/static/media/att.71340fae.svg","height":26,"width":26};